import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useState } from "react";
import Typography from "../Typography/Typography";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";

export const TicketReferencesModal = ({ show, handleClose, referal }) => {
  const [button] = useState(false);
  let count = 0;
  const refers = referal?.map((refer) => {
    count++;
    return (
      <Typography size="14px" className="mb-2">
        {count} - ارجاع شده در تاریخ {MiladiToShamsi(refer.created_at)} توسط{" "}
        {(refer.referee.FirstName ? refer.referee.FirstName : "") +
          " " +
          (refer.referee.LastName ? refer.referee.LastName : "")}{" "}
        به{" "}
        {(refer.responsible.FirstName ? refer.responsible.FirstName : "") +
          " " +
          (refer.responsible.LastName ? refer.responsible.LastName : "")}
      </Typography>
    );
  });
  return (
    <BootstrapModal
      modaltitle="تاریخچه ارجاعات"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">{refers}</div>
        <div className="col-12">
          <Button onclick={handleClose} bgColor="#f1416c" color="#fff">
            بستن
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
